import { css } from '@emotion/css';

export const listContainerStyles = css`
  > div > div {
    padding-inline-start: 2.4rem;
    padding-inline-end: 2.4rem;
  }
`;
